module.exports = __webpack_public_path__ + "static/img/carbonMatch.7c3fb874.png";